import http from '~/common/http';
import CustomerService from "~/services/customer";
export default {
    // getList(params, action) {
    //     return http.get('/api/customer-std/' + action, {
    //         params: params
    //     });
    // },

    create(params) {
        return http.post("/api/order-express/create", params);
    },

    update(params) {
        return http.put("/api/order-express/update", params);
    },

    delete(id) {
        return http.delete("/api/order-express/delete", {
            params: {
                id: id
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/OrderExpress.js